<template>
    <div class="problem-container">
        <div class="problem-common-wrapper search-wrapper">
            <div style="padding: 0 15px 10px">
                <h3>{{ problem.problemName }}</h3>
                <div v-html="problem.problemAnswer"></div>
            </div>
            <!--            <van-divider :style="{borderColor: '#33333314'}"></van-divider>-->
            <!--            <div class='file-container' v-if='problem.enclosureAnnex'>-->
            <!--                <div class="table-left">-->
            <!--                    <van-icon name="description" />-->
            <!--                </div>-->
            <!--                <div class="table-right">-->
            <!--                    <p>{{ problem.enclosureTitle }}</p>-->
            <!--                    <a :href="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${problem.enclosureAnnex}`">下载</a>-->
            <!--                    <p class='file-download' @click='downFile(problem)'>下载 ({{ problem.enclosureSize }})</p>-->
            <!--                    <p @click="pdfPreview(problem)">预览</p>-->
            <!--                </div>-->
            <!--            </div>-->
        </div>
    </div>
</template>
<script>
import { getProblemById, downFile } from "../../services/common";
import cloneDeep from "lodash.clonedeep";

export default {
    data() {
        return {
            problemId: "",
            problem: {},
            iconType: {
                img: "file-image",
                pdf: "file-pdf",
                text: "file-text",
                ppt: "file-ppt",
                word: "file-word",
            },
        };
    },
    mounted() {
        const id = this.$route.params.id;
        // this.$router.replace({
        //     path: `/helper/${id}`,
        //     name: 'HelperTwo'
        // })
        if (id) {
            getProblemById(id).then((res) => {
                if (res.code === 0) {
                    const data = cloneDeep(res.data);
                    document.title = data.problemName;
                    if (data.enclosureAnnex) {
                        // data.enclosureSize = this.formatFileSize(data.enclosureSize)
                        // data.enclosureTitle = (data.enclosureTitle).substring(0, (data.enclosureTitle).lastIndexOf('.'))
                    }
                    this.problem = data;
                } else if (res.code === 1001) {
                    this.$router.replace({
                        path: `/helper/${id}`,
                        name: "HelperTwo",
                    });
                    getProblemById(id).then((res) => {
                        if (res.code === 0) {
                            const data = cloneDeep(res.data);
                            document.title = data.problemName;
                            if (data.enclosureAnnex) {
                                // data.enclosureSize = this.formatFileSize(data.enclosureSize)
                                // data.enclosureTitle = (data.enclosureTitle).substring(0, (data.enclosureTitle).lastIndexOf('.'))
                            }
                            this.$forceUpdate();
                            this.$router.go(0);
                        }
                    });
                    this.$forceUpdate();
                }
            });
        }
    },
    methods: {
        /**
         * 格式化文件大小
         * @param {*} value
         */
        formatFileSize(size) {
            const value = Number(size);
            if (size && !isNaN(value)) {
                const units = ["B", "KB", "MB"];
                let index = 0;
                let k = value;
                if (value >= 1024) {
                    while (k > 1024) {
                        k = k / 1024;
                        index++;
                    }
                }
                return `${k.toFixed(2)}${units[index]}`;
            }
            return "-";
        },
        downFile(item) {
            // const href = 'https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/' + item.enclosureAnnex
            // // window.location.href = href
            // const link = document.createElement('a')
            // link.style.display = 'none'
            // link.href = href
            // link.setAttribute('download', item.enclosureTitle)
            // document.body.appendChild(link)
            // link.click()
            // setTimeout(() => {
            //     document.body.removeChild(link)
            // })
            downFile(item.enclosureAnnex).then((response) => {
                console.log(response.data);
                // const href = 'https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/' + item.enclosureAnnex
                // window.location.href = href
                // console.log('fetchMissionDataExport', response, response.headers['content-disposition'])
                const content = response.data;
                const resBlob = new Blob([content]);
                const reader = new FileReader();
                reader.readAsText(resBlob, "utf-8");
                reader.onload = () => {
                    try {
                        // 判断是否可以转化为json格式，可以就说明不是文件流，错误返回值
                        const res = JSON.parse(reader.result);
                        console.log(res);
                    } catch {
                        // 报错说明不能转化为json，是文件流，下载文件
                        console.log("res status", response.data);
                        // let blob = new Blob([data]); // 原 此种方式在pc端可以下载，但是手机端不行
                        const blob = new Blob([response.data], {
                            type: "application/pdf",
                        }); //
                        const blobUrl = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.style.display = "none";
                        a.download = item.enclosureTitle;
                        a.href = blobUrl;
                        a.click();
                    }
                };
                // const blob = new Blob([response.data], {
                //     type: 'application/pdf;charset-UTF-8'
                // })
                // const url = window.URL.createObjectURL(blob)
                // console.log(url, item.enclosureTitle)
                // const link = document.createElement('a')
                // link.style.display = 'none'
                // link.href = url
                // link.setAttribute('download', item.enclosureTitle)
                // document.body.appendChild(link)
                // link.click()
                // setTimeout(() => {
                //     document.body.removeChild(link)
                // })
            });
        },
    },
};
</script>
<style lang="less" scoped>
.problem-container {
    position: absolute;
    min-height: 100%;
    width: 100%;
    background: #f7f7f7ff;
    .problem-common-wrapper {
        background: white;
        p {
            margin: 0;
            line-height: 26px;
        }
        .table-left,
        .table-right {
            display: table-cell;
        }
        .table-left {
            vertical-align: middle;
        }
        h3 {
            margin: 0 0 10px;
            padding-top: 10px;
            font-weight: bold;
        }
        .file-container {
            display: inline-block;
            padding: 10px;
            p {
                font-size: 13px;
                margin: 0;
                line-height: 30px;
                &.file-download {
                    cursor: pointer;
                    color: #5cadff;
                    font-size: 12px;
                }
            }
            i {
                padding: 6px;
                margin-right: 10px;
                border-radius: 5px;
                border: 1px solid #dfe0ebff;
                font-size: 40px;
                color: #333333ff;
            }
        }
    }
}
</style>
<style lang="less">
.problem-container {
}
</style>
